import type {PagesData} from '@wix/document-services-types'

const COMPONENT_TYPES = {
    ANCHOR: 'wysiwyg.common.components.anchor.viewer.Anchor',
    APP_CONTROLLER: 'platform.components.AppController',
    BACK_TO_TOP_BUTTON: 'wysiwyg.viewer.components.BackToTopButton',
    BOX_SLIDE_SHOW: 'wysiwyg.viewer.components.BoxSlideShow',
    BOX_SLIDE_SHOW_SLIDE: 'wysiwyg.viewer.components.BoxSlideShowSlide',
    COLUMN: 'wysiwyg.viewer.components.Column',
    CONTACT_FORM: 'wysiwyg.viewer.components.ContactForm',
    CONTAINER: 'mobile.core.components.Container',
    DROP_DOWN_MENU: 'wysiwyg.viewer.components.menus.DropDownMenu',
    VERTICAL_MENU: 'wysiwyg.common.components.verticalmenu.viewer.VerticalMenu',
    EXPANDABLE_MENU: 'wysiwyg.viewer.components.ExpandableMenu',
    STYLABLE_HORIZONTAL_MENU: 'wixui.StylableHorizontalMenu',
    MEGA_MENU_CONTAINER_ITEM: 'wixui.MegaMenuContainerItem',
    BREADCRUMBS: 'wixui.Breadcrumbs',
    HEADER_CONTAINER: 'wysiwyg.viewer.components.HeaderContainer',
    FOOTER_CONTAINER: 'wysiwyg.viewer.components.FooterContainer',
    MASTER_PAGE: 'mobile.core.components.MasterPage',
    MEDIA_CONTAINER: 'wysiwyg.viewer.components.MediaContainer',
    LOGIN_BUTTON: 'wysiwyg.viewer.components.LoginButton',
    MEDIA_PLAYER: 'wysiwyg.viewer.components.MediaPlayer',
    MEDIA_CONTROLS: 'wysiwyg.viewer.components.MediaControls',
    MEDIA_OVERLAY_CONTROLS: 'wysiwyg.viewer.components.MediaOverlayControls',
    PAGE: 'mobile.core.components.Page',
    PAGES_CONTAINER: 'wysiwyg.viewer.components.PagesContainer',
    GOOGLE_MAP: 'wysiwyg.viewer.components.GoogleMap',
    PINTEREST_PIN_IT_WIDGET: 'wysiwyg.common.components.pinterestpinit.viewer.PinterestPinIt',
    POPUP_CLOSE_ICON_BUTTON: 'wysiwyg.viewer.components.PopupCloseIconButton',
    QUICK_ACTION_BAR_ITEM: 'wysiwyg.viewer.components.QuickActionBarItem',
    QUICK_ACTION_BAR: 'wysiwyg.viewer.components.QuickActionBar',
    REPEATER: 'wysiwyg.viewer.components.Repeater',
    DYNAMIC_REPEATER: 'wixui.DynamicRepeater',
    FILE_UPLOADER: 'wysiwyg.viewer.components.inputs.FileUploader',
    INLINE_POPUP: 'wysiwyg.viewer.components.InlinePopup',
    SITE_BUTTON: 'wysiwyg.viewer.components.SiteButton',
    STYLABLE_BUTTON: 'wixui.StylableButton',
    LOGIN_SOCIAL_BAR: 'wysiwyg.viewer.components.LoginSocialBar',
    SINGLE_AUDIO_PLAYER: 'wysiwyg.common.components.singleaudioplayer.viewer.SingleAudioPlayer',
    STRIP_CONTAINER_SLIDE_SHOW: 'wysiwyg.viewer.components.StripContainerSlideShow',
    STRIP_CONTAINER_SLIDE_SHOW_SLIDE: 'wysiwyg.viewer.components.StripContainerSlideShowSlide',
    STRIP_COLUMNS_CONTAINER: 'wysiwyg.viewer.components.StripColumnsContainer',
    SVG_SHAPE: 'wysiwyg.viewer.components.svgshape.SvgShape',
    TPA_GLUED_WIDGET: 'wysiwyg.viewer.components.tpapps.TPAGluedWidget',
    TPA_MULTI_SECTION: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    TPA_MODAL: 'wysiwyg.viewer.components.tpapps.TPAModal',
    TPA_SECTION: 'wysiwyg.viewer.components.tpapps.TPASection',
    TPA_WIDGET: 'wysiwyg.viewer.components.tpapps.TPAWidget',
    VECTOR_IMAGE: 'wysiwyg.viewer.components.VectorImage',
    VK_SHARE_BUTTON: 'wysiwyg.viewer.components.VKShareButton',
    HTML_COMPONENT: 'wysiwyg.viewer.components.HtmlComponent',
    WPHOTO: 'wysiwyg.viewer.components.WPhoto',
    IMAGE_BUTTON: 'wysiwyg.common.components.imagebutton.viewer.ImageButton',
    IMAGEX: 'wixui.ImageX',
    APP_PART: 'wixapps.integration.components.AppPart',
    APP_PART2: 'wixapps.integration.components.AppPart2',
    APP_PAGE: 'wixapps.integration.components.AppPage',
    WRICHTEXT: 'wysiwyg.viewer.components.WRichText',
    TWITTER_TWEET: 'wysiwyg.viewer.components.WTwitterTweet',
    POPUP_CONTAINER: 'wysiwyg.viewer.components.PopupContainer',
    MATRIX_GALLERY: 'wysiwyg.viewer.components.MatrixGallery',
    TINY_MENU: 'wysiwyg.viewer.components.mobile.TinyMenu',
    VERTICAL_ANCHORS_MENU: 'wysiwyg.common.components.verticalanchorsmenu.viewer.VerticalAnchorsMenu',
    TPA_3DGALLERY: 'wysiwyg.viewer.components.tpapps.TPA3DGallery',
    SLIDER_GALLERY: 'wysiwyg.viewer.components.SliderGallery',
    SITE_BACKGROUND: 'wysiwyg.viewer.components.SiteBackground',
    PAGINATED_GRID_GALLERY: 'wysiwyg.viewer.components.PaginatedGridGallery',
    POPOVER: 'wysiwyg.viewer.components.Popover',
    GROUP: 'wysiwyg.viewer.components.Group',
    REF_COMPONENT: 'wysiwyg.viewer.components.RefComponent',
    CHECK_BOX_GROUP: 'wysiwyg.viewer.components.inputs.CheckboxGroup',
    APP_WIDGET: 'platform.components.AppWidget',
    SLOT_PLACEHOLDER: 'wixui.SlotsPlaceholder',
    RESPONSIVE_SECTION: 'responsive.components.Section',
    HEADER_SECTION: 'responsive.components.HeaderSection',
    CLASSIC_SECTION: 'wysiwyg.viewer.components.ClassicSection',
    COLLAPSIBLE_TEXT: 'wixui.CollapsibleText',
    SITE_REGION_CONTAINER: 'wysiwyg.viewer.components.SiteRegionContainer',
    TABS: 'wixui.Tabs',
    SINGLE_TAB: 'wixui.SingleTab',
    SLIDE_SHOW: 'wysiwyg.viewer.components.StripContainerSlideShow',
    SLIDE_SHOW_SLIDE: 'wysiwyg.viewer.components.StripContainerSlideShowSlide',
    VERTICAL_LINE: 'wysiwyg.viewer.components.VerticalLine'
}

const PAGE_DATA_TYPES = {
    page: 'Page',
    appPage: 'AppPage'
}

const DEFAULT_PAGE_DATA: Partial<PagesData> = {
    type: 'Page',
    hideTitle: true,
    icon: '',
    descriptionSEO: '',
    metaKeywordsSEO: '',
    pageTitleSEO: 'page-title-seo',
    hidePage: false,
    underConstruction: false,
    tpaApplicationId: 0,
    pageSecurity: {
        requireLogin: false
    },
    indexable: true,
    isLandingPage: false,
    isPopup: false,
    pageBackgrounds: {
        desktop: {
            custom: true,
            isPreset: true
        },
        mobile: {
            custom: true,
            isPreset: true
        }
    },
    metaData: {
        pageId: 'masterPage'
    }
}

export {DEFAULT_PAGE_DATA, COMPONENT_TYPES, PAGE_DATA_TYPES}
